import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from '../link/link';
import EnhancementButtonsContainer from '../enhancementButtons/enhancementButtonsContainer';
import ButtonsToolbar from './buttonsToolbar';
import viewerFeaturePropTypes from '../viewerFeaturePropTypes';

export default function Toolbar(props) {
  const { sidePanelOpen, accessibleFormatUrl, isSearching } = props;

  return (
    <nav
      className={classnames('toolbar u-hide-from-print', {
        'side-panel-open': sidePanelOpen,
      })}
      id="toolbar" // For AA activity map
    >
      {accessibleFormatUrl && (
        <Link href={accessibleFormatUrl} className="u-hide-visually">
          This is the Enhanced Reader view. For maximum accessibility screen reader users should use
          the HTML format which is available on the article page for most content.
        </Link>
      )}
      <div className="toolbar-panel enhancements-panel">
        <EnhancementButtonsContainer />
      </div>
      <div className={classnames('toolbar-panel toolbox-panel', {
        'adjust-width': isSearching,
      })}
      >
        <ButtonsToolbar {...props} />
      </div>
    </nav>
  );
}

Toolbar.propTypes = {
  accessibleFormatUrl: PropTypes.string,
  downloadUrl: PropTypes.string,
  sidePanelOpen: PropTypes.bool,
  viewerFeature: PropTypes.shape(viewerFeaturePropTypes),
  isSearching: PropTypes.bool,
};

Toolbar.defaultProps = {
  accessibleFormatUrl: null,
  downloadUrl: '',
  sidePanelOpen: false,
  isSearching: false,
  viewerFeature: {
    print: false,
    save: false,
    viewOnlyDisclaimer: false,
  },
};
